var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"src":"https://tithe.ly/give/?c=1401851"}})
}
var staticRenderFns = []

export { render, staticRenderFns }